// extracted by mini-css-extract-plugin
export default {"container":"aUfc91","divider":"ULBVxE"};